import { render } from "./ServOrder.vue?vue&type=template&id=17c3d83b"
import script from "./ServOrder.vue?vue&type=script&lang=js"
export * from "./ServOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__